/* eslint-disable header/header */
export const name = "@azure/msal-node";
export const version = "1.18.3";
